<template>
  <div>
    <v-card flat>
      <v-list-item>
        <v-list-item-content two-line class="pt-0">
          <v-list-item-title class="headline"
            >Traitement de la demande</v-list-item-title
          >
          <v-list-item-subtitle>{{ typeDemande }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="6">
            <v-text-field
              filled
              dense
              v-model="demandeur"
              label="Demandeur"
              readonly
              hide-details="auto"
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              filled
              dense
              v-model="dateCreation"
              label="Date de la demande"
              readonly
              hide-details="auto"
            />
          </v-col>

          <v-col cols="12" v-if="legende">
            <span class="text-caption"> Légende</span>
            <v-chip class="ma-1" label color="accent">Modification</v-chip>
            <v-chip class="ma-1" label color="secondary">Ajout</v-chip>
            <v-chip class="ma-1" label color="error">Suppression</v-chip>

            <span class="text-caption">
              Vous pouvez activer l'icone
              <v-chip small color="error">
                <v-icon color="white">undo</v-icon>
              </v-chip>
              pour annuler les suppressions dans les listes.</span
            >
          </v-col>

          <v-col cols="12">
            <v-textarea
              filled
              label="Commentaire"
              v-model="commentaire"
              readonly
              hide-details="auto"
            ></v-textarea>
          </v-col>

          <v-col cols="12" v-if="motifRefus">
            <v-textarea
              filled
              label="Motif de refus"
              v-model="motifRefus"
              readonly
              hide-details="auto"
            ></v-textarea>
          </v-col>

          <v-col cols="12" v-if="control.complementsPossible">
            <v-simple-table dense class="complement">
              <thead>
                <tr>
                  <th scope="col">Date demande complément</th>
                  <th scope="col">Demandeur</th>
                  <th scope="col">Demande</th>
                  <th scope="col">Réponse</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(c, i) in complements" :key="`complement-${i}`">
                  <td>{{ dateTimeFormatter(c.created) }}</td>
                  <td>{{ c.demandeur.libelle }}</td>
                  <td>{{ c.demande }}</td>
                  <td v-if="c.reponse">{{ c.reponse }}</td>
                  <td v-else-if="!control.terminer">
                    <v-btn
                      class="ma-2"
                      color="secondary"
                      v-if="control.isDemandeur"
                      @click="ouvrirRepondreComplement(c.id)"
                    >
                      Repondre
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="control.dialogRepondre" persistent max-width="50%">
      <v-card>
        <v-card-title class="info white--text">
          <v-icon color="white">mdi-comment-alert</v-icon> Répondre à une
          demande de complément d'information
        </v-card-title>

        <v-card-text class="body-1">
          <p class="pt-4">
            Veuillez saisir la réponse à la demande d'information
            complémentaire.
          </p>

          <v-textarea
            v-model="control.reponseComplement"
            filled
            label="Réponse"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="controlAction.repondreComplement"
            :loading="control.repondreComplement"
          >
            Repondre
          </v-btn>
          <v-btn
            text
            @click="
              control.dialogRepondre = false;
              control.repondreComplementId = null;
            "
          >
            Annuler
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DateFormatter from '@/plugins/mixins/DateFormatter';
export default {
  inject: ['control', 'controlAction'],
  mixins: [DateFormatter],
  props: {
    demandeur: String,
    typeDemande: String,
    codeTypeDemande: String,
    dateCreation: String,
    commentaire: String,
    complements: Array,
    motifRefus: String,
  },
  computed: {
    legende() {
      return 'modification' === this.codeTypeDemande;
    },
  },
  methods: {
    ouvrirRepondreComplement(id) {
      this.control.reponseComplement = null;
      this.control.repondreComplementId = id;
      this.control.dialogRepondre = true;
    },
  },
};
</script>
<style scoped>
.complement {
  animation-duration: 2s;
  border-style: solid;
  border-color: red;
  animation-name: clignoter;
  animation-iteration-count: 3;
  transition: none;
}
@keyframes clignoter {
  0% {
    border-color: red;
  }
  40% {
    border-color: white;
  }
  100% {
    border-color: red;
  }
}
</style>
